/* eslint-disable */
function socialPixelsCode(debug) {
    let isSensitive;
    let excludeTopics = ['1634', '1663', '1664', '1669', '1695', '1700', '1703', '1705', '1707', '1709', '1711', '1719', '1756', '1760', '1761', '1762', '1783', '1814', '1818', '1819', '1835', '1840', '2730', '2756', '2857', '2950', '2952', '2953', '3079', '3236', '3539', '3540', '3541', '3552', '3571', '3607', '3608', '3623', '3631', '3637', '3644', '3838', '3927', '3928', '3930', '3937', '3939', '3950', '3951', '3954', '3958', '3962', '3963', '3965', '3966', '3971', '3989', '4010', '4048', '4049', '4050', '4052', '4058', '4099', '4119', '4121', '4140', '4203', '4222', '4227', '4228', '4236', '4242', '4251', '4254', '4257', '5555', '6041', '18091', '18092', '18093', '18094', '4298', '1678', '2949', '2948', '2947', '1624', '1833', '1674', '4249', '1628', '2951', '1626', '3554', '3553', '4272', '1633', '3624', '3625', '3610'];
    let currentURL = (window.location && window.location.href) || '';
    let isCare = ((window.s_pagename && (window.s_pagename.indexOf('doctor.webmd.com') > -1 || window.s_pagename.indexOf('doctor.staging.webmd.com') > -1)) || (currentURL.indexOf('doctor.webmd.com') > -1 || currentURL.indexOf('doctor.staging.webmd.com') > -1));
    let isVitals = ((window.s_pagename && (window.s_pagename.indexOf('vitals.com') > -1 || window.s_pagename.indexOf('staging.vitals.com') > -1)) || (currentURL.indexOf('vitals.com') > -1 || currentURL.indexOf('staging.vitals.com') > -1));

    

    // If the 'conmktvid' parameter is present, skip load other social media pixels
    if (shouldRemoveAds()) {
        debug("Social media pixels initialization skipped due to 'conmktvid' parameter in URL.");
        // Only load Facebook pixel, skip others
        pixelForFacebook(); // Load Facebook pixel
        return; // Exit early to prevent loading other pixels
    }


    //PPE-411484 don't execute on member pages
    // if we are on member or webmdrx pages, return immediately
    if ((/member.|webmdrx\./).test(location.host)) {
        return;
    }

    if (window.s_topic) {
        isSensitive = s_topic.match(/^7\d\d\d/gi);
    }

    /**
     *  PPE-462140 : Suppress fb, twitter, reddit, tiktok, pinterest pixels based on geo location
     *  through ads admin tool data.
     */
    if (isVitals || (window.s_topic && !isSensitive && excludeTopics.indexOf(window.s_topic) === -1)) {

    let vendorConfig = {};
		let pixelsLocation = { faceBook: false, twitter: false, reddit: false, pinterest: false };
		let vendorLoad = Object.assign({}, pixelsLocation);
		if(window.globalConfig && window.globalConfig.ads) {
			vendorConfig = window.globalConfig.ads.vendorConfig;
			let location = getCookie(' gtinfo');
			location = location ? JSON.parse(location) : {};
			let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
			Object.keys(pixelsLocation).forEach(function (pixel) {
				let pixelConfig = vendorConfig[pixel] ? vendorConfig[pixel] : {};
				let locationList = pixelConfig.location ? pixelConfig.location : [];
				// If no location is selected or all the locations are selected or the loading geo location is included,
				// then marking pixelsLocation is true for the respective pixel
				if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
					pixelsLocation[pixel] = true;
				}
				// If suppose the location list is given with some countries but the gtinfo is empty, then
				// we are loading the vendors without any further check as we don't have proper gtinfo data to block
				if (countryCode == '' && locationList.length > 0 && locationList.length < 249) {
					vendorLoad[pixel] = true;
				}
			})
		} else {
			// Making vendor load to true for all the pixels when there is no ads tool data present.
			Object.keys(vendorLoad).forEach(function (pixel) {
				vendorLoad[pixel] = true;
			})
		}
        
		let fbDisable = ( vendorConfig.faceBook && vendorConfig.faceBook.disable ) ? true : false;
		if ( vendorLoad['faceBook'] || (!fbDisable && pixelsLocation['faceBook']) || (fbDisable && !pixelsLocation['faceBook']) ) {
			pixelForFacebook();
		}

        if (!(isCare || isVitals)) {

			let twitterDisable = ( vendorConfig.twitter && vendorConfig.twitter.disable ) ? true : false;
			if ( vendorLoad['twitter'] || (!twitterDisable && pixelsLocation['twitter']) || (twitterDisable && !pixelsLocation['twitter']) ) {
				pixelForTwitter();
			}
			let redditDisable = ( vendorConfig.reddit && vendorConfig.reddit.disable ) ? true : false;
			if ( vendorLoad['reddit'] || (!redditDisable && pixelsLocation['reddit']) || (redditDisable && !pixelsLocation['reddit']) ) {
				pixelForReddit();
			}
			let pinterestDisable = ( vendorConfig.pinterest && vendorConfig.pinterest.disable ) ? true : false;
			if ( vendorLoad['pinterest'] || (!pinterestDisable && pixelsLocation['pinterest']) || (pinterestDisable && !pixelsLocation['pinterest']) ) {
				pixelForPinterest();
			}

        }
    }

    function pixelForFacebook() {
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
            /**
             * performance mark to spot when facebook code has started loading
             */
            
            try {
                window.performance.mark("facebook-load-start");
                window.performance.measure('measure-facebook-load-start', 'ads-code-load', 'facebook-load-start');
                debug('(Perf-Mark) facebook load started -> ' + window.performance.getEntriesByName('measure-facebook-load-start', 'measure')[0].duration);
            } catch (error) {
                debug(error)
            }
            
            t.onload = function() {
                /**
                 * performance mark to spot when facebook code has loaded
                 */
                try {
                    window.performance.mark('facebook-loaded');
                    window.performance.measure('measure-facebook-loaded', 'ads-code-load', 'facebook-loaded');
                    debug('(Perf-Mark) facebook loaded -> ' + window.performance.getEntriesByName('measure-facebook-loaded', 'measure')[0].duration);
                } catch (error) {
                    debug(error)
                }
            }
        }(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js'));
		// PPE-416461 add this auto config to restrict fb to access the page actions
        if(window.location.href.indexOf("/women/") > -1){
            // load only live domain and bypass for staging
            if(window.location.href.indexOf("www.webmd.com") > -1 ){
                fbq('set', 'autoConfig', 'false', '428750600651790');
            }   
        }else{
            fbq('set', 'autoConfig', 'false', '428750600651790');
        }
        fbq('init', '428750600651790');
        fbq('track', 'PageView');
        if (!isVitals && window.s_topic) {
            fbq('track', 'ViewContent', {content_category: window.s_topic});
        }
        fbq('track', 'Audience', {audience: getAudience()});
    }
    // Function to check if ads should be removed based on the 'conmktvid' parameter
        function shouldRemoveAds() {
            if (typeof window !== 'undefined' && window.location) {
                return window.location.href.indexOf('conmktvid') > -1;
            }
            return false; // Return false if the checks fail
        }

    function pixelForTwitter() {
        !(function (e, t, n, s, u, a) {
            e.twq || (s = e.twq = function () {
                s.exe ? s.exe(...arguments) : s.queue.push(arguments);
            },
                s.version = '1.1',
                s.queue = [],
                u = t.createElement(n),
                u.async = !0,
                u.src = '//static.ads-twitter.com/uwt.js',
                a = t.getElementsByTagName(n)[0],
                a.parentNode.insertBefore(u, a));
                /**
                 * performance mark to spot when twitter code has started loading
                 */
                try {
                    window.performance.mark("twitter-load-start");
                    window.performance.measure('measure-twitter-load-start', 'ads-code-load', 'twitter-load-start');
                    debug('(Perf-Mark) twitter load started -> ' + window.performance.getEntriesByName('measure-twitter-load-start', 'measure')[0].duration);
                } catch (error) {
                    debug(error)
                }

                u.onload = function() {
                    /**
                     * performance mark to spot when twitter code has loaded
                     */
                    try {
                        window.performance.mark('twitter-loaded');
                        window.performance.measure('measure-twitter-loaded', 'ads-code-load', 'twitter-loaded');
                        debug('(Perf-Mark) twitter loaded -> ' + window.performance.getEntriesByName('measure-twitter-loaded', 'measure')[0].duration);  
                    } catch (error) {
                        debug(error)
                    }
                }
        }(window, document, 'script'));

        // Insert Twitter Pixel ID and Standard Event data below
        twq('init', 'nxo3v');
        twq('track', 'PageView');
    }

    function pixelForPinterest() {
        !(function (e) {
            if (!window.pintrk) {
                window.pintrk = function () {
                    window.pintrk.queue.push(Array.prototype.slice.call(arguments));
                };
                let n = window.pintrk;
                n.queue = [],
                    n.version = '3.0';
                let t = document.createElement('script');
                t.async = !0,
                    t.src = e;
                let r = document.getElementsByTagName('script')[0];
                r.parentNode.insertBefore(t, r);
                /**
                 * performance mark to spot when pinterest code has started loading
                 */
                try {
                    window.performance.mark("pinterest-load-start");
                    window.performance.measure('measure-pinterest-load-start', 'ads-code-load', 'pinterest-load-start');
                    debug('(Perf-Mark) pinterest load started -> ' + window.performance.getEntriesByName('measure-pinterest-load-start', 'measure')[0].duration);
                } catch (error) {
                    debug(error)
                }

                t.onload = function() {
                    /**
                     * performance mark to spot when pinterest code has loaded
                     */
                    try {
                        window.performance.mark('pinterest-loaded');
                        window.performance.measure('measure-pinterest-loaded', 'ads-code-load', 'pinterest-loaded');
                        debug('(Perf-Mark) pinterest loaded -> ' + window.performance.getEntriesByName('measure-pinterest-loaded', 'measure')[0].duration);
                    } catch (error) {
                        debug(error)
                    }
                }
            }
        }('https://s.pinimg.com/ct/core.js'));
        pintrk('load', '2618142259440');
        pintrk('page');
        pintrk('track', 'pagevisit');
    }

    function pixelForReddit() {
        !function (w, d) {
            if (!w.rdt) {
                var p = w.rdt = function () {
                    p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments)
                };
                p.callQueue = [];
                var t = d.createElement("script");
                t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
                var s = d.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(t, s)
                /**
                 * performance mark to spot when reddit code has started loading
                 */
                try {
                    window.performance.mark("reddit-load-start");
                    window.performance.measure('measure-reddit-load-start', 'ads-code-load', 'reddit-load-start');
                    debug('(Perf-Mark) reddit load started -> ' + window.performance.getEntriesByName('measure-reddit-load-start', 'measure')[0].duration);
                } catch (error) {
                    debug(error)
                }

                t.onload = function() {
                    /**
                     * performance mark to spot when reddit code has loaded
                     */
                    try {
                        window.performance.mark('reddit-loaded');
                        window.performance.measure('measure-reddit-loaded', 'ads-code-load', 'reddit-loaded');
                        debug('(Perf-Mark) reddit loaded -> ' + window.performance.getEntriesByName('measure-reddit-loaded', 'measure')[0].duration);
                    } catch (error) {
                        debug(error)
                    }
                }
            }
        }(window, document);
        rdt('init', 't2_109a14pl');
        rdt('track', 'PageVisit');
    }

    function getAudience() {
        var cmt = getCookie('cmt')
        if (cmt) {
            return ['campaigns'].reduce(function (obj, key) {
                obj[key] = JSON.parse(cmt)[key];
                return obj;
            }, {});
        }
    }

    function getCookie(name) {
        const cookieDict = document.cookie.split(';')
            .map((x) => x.split('='))
            .reduce((accum, current) => {
                accum[current[0]] = current[1];
                return accum;
            }, Object());
        return cookieDict[name];
    }

};

export {socialPixelsCode};
